import { render, staticRenderFns } from "./question-display.vue?vue&type=template&id=1b0c551a&scoped=true"
import script from "./question-display.vue?vue&type=script&lang=js"
export * from "./question-display.vue?vue&type=script&lang=js"
import style0 from "./question-display.vue?vue&type=style&index=0&id=1b0c551a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0c551a",
  null
  
)

export default component.exports